import {
  setActiveAvitoDialog,
  setActiveDialog,
  setActiveInstagramDialog,
  setActiveTelegramDialog,
  setActiveTgBotDialog,
  setActiveVkDialog,
  setActiveWhatsappDialog,
  setDialogs,
  setIsLoadingTgBotDialog,
  setLastChatMessage,
  setNewDialog,
  setSettings,
} from "../../../store/slices/dialogSlice";
import { removeUser } from "../../../store/slices/userSlice";
import { errorToast } from "../../methods/toast";
import { $authHost, $hostTest } from "../http";

const userId = localStorage.getItem("@storage_User_Id");

export const getAllDialogs = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(`/dialog/list?userId=${id}`);

      if (data.code === 200) {
        dispatch(setDialogs(data.dialogs.reverse()));
        dispatch(setNewDialog(null));
      } else {
        errorToast(data.message || "Неизвестная ошибка");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast("Ошибка получения данных. Пожалуйста, попробуйте позже.");
      }
      console.error("Error in getAllDialogs:", error);
    }
  };
};

export const getDialog = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(`/dialog/get?id=${id}`);

      if (data.code === 200) {
        dispatch(setActiveDialog(data.dialog));
        dispatch(setSettings(data.dialog.settings));
      } else {
        errorToast(data.message || "Неизвестная ошибка");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast("Ошибка получения данных. Пожалуйста, попробуйте позже.");
      }
      console.error("Error in getAllDialogs:", error);
    }
  };
};

export const postMessage = (dataMessage) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.post(`/chat/send`, dataMessage);

      if (data.code === 200) {
        dispatch(setLastChatMessage(data.lastChatMessage));
        dispatch(getAllDialogs(dataMessage.userId));
      } else {
        errorToast(data.message || "Неизвестная ошибка при отправке сообщения");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast("Ошибка отправки сообщения. Пожалуйста, попробуйте позже.");
      }
      console.error("postMessage error:", error);
    }
  };
};

export const deleteDialog = (id, userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.delete(`/dialog/delete?id=${id}`);

      if (data.code === 200) {
        dispatch(getAllDialogs(userId));
      } else {
        errorToast(data.message || "Неизвестная ошибка при удалении диалога");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast("Ошибка удаления диалога. Пожалуйста, попробуйте позже.");
      }
      console.error("deleteDialog error:", error);
    }
  };
};

export const unIgnoreDialog = (dialogId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(`/dialog/unignore`, { dialogId });

      if (data.code === 200) {
        dispatch(getAllDialogs(userId));
        // console.log(data);
      } else {
        errorToast(data.message || "Неизвестная ошибка при удалении игнора");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast("Ошибка удаления игнора. Пожалуйста, попробуйте позже.");
      }
      console.error("unignoreDialog error:", error);
    }
  };
};

// messengers

export const getTelegramChatHistory = (dialogId, setLoading = () => {}) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.get(`/dialog/get?id=${dialogId}`);

      if (data.code === 200) {
        dispatch(setActiveTelegramDialog(data.dialog));
        setLoading(false);
      } else {
        errorToast("Не удалось получить историю чата");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast(
          "Ошибка при получении данных. Пожалуйста, попробуйте позже."
        );
      }
      console.error("getTelegramChatHistory error:", error);
    }
  };
};

export const getWhatsappChatHistory = (dialogId, setLoading = () => {}) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.get(`/dialog/get?id=${dialogId}`);

      if (data.code === 200) {
        dispatch(setActiveWhatsappDialog(data.dialog));
        setLoading(false);
      } else {
        errorToast("Не удалось получить историю чата");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast(
          "Ошибка при получении данных. Пожалуйста, попробуйте позже."
        );
      }
      console.error("getWhatsappChatHistory error:", error);
    }
  };
};

export const getInstagramChatHistory = (dialogId, setLoading = () => {}) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $hostTest.get(`/dialog/get?id=${dialogId}`);

      if (data.code === 200) {
        dispatch(setActiveInstagramDialog(data.dialog));
        setLoading(false);
        console.log("getInstagramChatHistory", data);
      } else {
        setLoading(false);
        errorToast("Ошибка получения истории чата");
      }
    } catch (error) {
      setLoading(false);

      if (error.response) {
        // Обработка ошибок на уровне ответа
        if (error.response.status === 401) {
          dispatch(removeUser());
          errorToast("Вы не авторизованы. Пожалуйста, войдите снова.");
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        // Ошибка связи с сервером
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        // Ошибка на уровне запроса или внутренней логики
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("getInstagramChatHistory error:", error);
    }
  };
};

export const getAvitoChatHistory = (dialogId, setLoading = () => {}) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.get(`/dialog/get?id=${dialogId}`);

      if (data.code === 200) {
        dispatch(setActiveAvitoDialog(data.dialog));
        setLoading(false);
      } else {
        errorToast("Не удалось получить историю чата");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast(
          "Ошибка при получении данных. Пожалуйста, попробуйте позже."
        );
      }
      console.error("getAvitoChatHistory error:", error);
    }
  };
};

export const getVkChatHistory = (dialogId, setLoading = () => {}) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.get(`/dialog/get?id=${dialogId}`);

      if (data.code === 200) {
        dispatch(setActiveVkDialog(data.dialog));
        setLoading(false);
        // console.log("getVkChatHistory", data);
      } else if (data.code === 401) {
        dispatch(removeUser());
      }
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        dispatch(removeUser());
      }
      console.log("getVkChatHistory error:", error);
    }
  };
};

export const getTgBotChatHistory = (dialogId) => {
  return async (dispatch) => {
    dispatch(setIsLoadingTgBotDialog(true));
    try {
      const { data } = await $authHost.get(`/dialog/get?id=${dialogId}`);

      if (data.code === 200) {
        dispatch(setActiveTgBotDialog(data.dialog));
        dispatch(setIsLoadingTgBotDialog(false));
        // console.log("getTgBotChatHistory", data);
      }
    } catch (error) {
      dispatch(setIsLoadingTgBotDialog(false));
      if (error.response.status === 401) {
        dispatch(removeUser());
      }
      console.log("getTgBotChatHistory error:", error);
    }
  };
};
